export interface PageMeta {
    title: string,
    keywords: string,
    description: string,
    published: boolean
}
